export default __webpack_public_path__ + "/dist/images/Platinum.63ad242ba5fc28a0255091dfa7ac8e56.svg";